<template>
    <div>
        <button
            type="button"
            aria-label="Quick links navigation"
            aria-controls="course__quick-links__container"
            :aria-selected="expanded"
            class="flex justify-between items-center w-full block lg:inline-block lg:w-auto appearance-none lg:bg-smarta-green lg:text-white lg:rounded-md lg:py-4 lg:px-8 lg:mt-6"
            @click="expanded = !expanded"
        >
            <div class="flex items-center justify-between w-full font-bold text-xl">
                <h4 class="lg:text-white text-2xl lg:text-xl pr-2">Quick links</h4>
                <fa-icon
                    :class="{
                        'transition-transform': true,
                        '-rotate-180': expanded,
                        'rotate-0': !expanded
                    }"
                    :icon="['fas', 'chevron-down']"
                    size="md"
                    fixed-width
                />
            </div>
        </button>
        <div class="flex flex-col bg-white space-y-8">
            <ul
                v-if="expanded"
                id="course__quick-links__container divide-y-2 divide-smarta-blue"
                :aria-hidden="!expanded"
            >
                <li
                    v-for="item in options"
                    :key="item.link"
                >
                    <button
                        v-if="item.show"
                        type="button"
                        class="lg:text-xl font-bold block w-full appearance-none cursor-pointer py-6 lg:py-8"
                        @click.prevent="scrollToSection(item.link)"
                    >
                        {{ item.label }}
                    </button>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
export default {
    name: 'MicrocourseQuickLinks',

    props: {
        item: {
            type: Object,
            required: true
        },

        options: {
            type: Object,
            required: true
        }
    },

    data () {
        return {
            expanded: false
        }
    },

    methods: {
        scrollToSection (id) {
            window.scrollToElement(id)
        }
    }
}
</script>
